import React from 'react';
import { ColorDot, COLOR_LABELS } from '../persistencia/colorLabels';
import { SEMAFORO_EJEMPLO } from './landingConstants';

const PAIN_POINTS = [
  'Las encuestas de satisfacción llegan tarde: el alumno ya decidió abandonar.',
  'Las planillas de seguimiento viven desconectadas del CRM y del LMS.',
  'HubSpot muestra el estado comercial, pero no el avance académico real.',
];

export const LandingProblem = () => (
  <section id="que-hace" className="max-w-7xl mx-auto px-6 py-20" data-testid="landing-problem">
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      <div>
        <p className="text-sm font-semibold text-emerald-700 mb-3">El problema</p>
        <h2 className="font-manrope text-3xl sm:text-4xl font-bold text-gray-900 mb-6 leading-tight">
          Los alumnos abandonan sin previo aviso
        </h2>
        <p className="text-base text-gray-600 leading-relaxed mb-6">
          Hoy la señal de alarma llega cuando ya es tarde para actuar. La información de riesgo está repartida
          entre el LMS, el CRM y planillas sueltas, y nadie la mira junta a tiempo.
        </p>
        <ul className="space-y-3">
          {PAIN_POINTS.map((point, idx) => (
            <li key={idx} className="flex items-start gap-3 text-sm text-gray-700">
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-600 shrink-0" />
              {point}
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-gray-50 border border-gray-100 rounded-2xl p-6 sm:p-8" data-testid="landing-semaforo-panel">
        <div className="flex items-center justify-between mb-5">
          <p className="font-manrope font-semibold text-gray-900">Semáforo de riesgo</p>
          <span className="text-[11px] font-mono text-gray-400">Ejemplo ilustrativo</span>
        </div>
        <div className="space-y-3">
          {SEMAFORO_EJEMPLO.map((row) => (
            <div key={row.color} className="flex items-center gap-3" data-testid={`landing-semaforo-row-${row.color}`}>
              <ColorDot color={row.color} size={12} />
              <span className="text-sm text-gray-600 flex-1">{COLOR_LABELS[row.color]}</span>
              <span className="font-mono text-sm font-semibold text-gray-900 tabular-nums">{row.count}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
